import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  border: none;
`;

export const LegendStyled = styled.legend`
  font-size: ${props => props.theme.font.size[props.size]};
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props => props.theme.color.wfBlack};
  margin-bottom: ${props => props.theme.spacing.xsmall};
`;
